import { Header } from '@Components/Text';
import { HeaderProps } from '@Components/Text/Header/types';
import styled from 'styled-components';
import { Button } from '../../Buttons';

export const StyledSelectButton = styled(Button).attrs({})<{
	hasValue: boolean;
}>`
	&&& {
		justify-content: flex-end;
	}
	background-color: ${({ hasValue }) =>
		hasValue ? '#E8EAED !important' : '#EFF2F5'};
`;

export const StyledContentContainer = styled.ul<{ isAbove: boolean }>`
	position: absolute;
	padding: 8px 0;
	z-index: 1000;
	width: 100%;
	max-height: 300px;
	overflow: auto;
	background: #ffffff;
	box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
	border-radius: 8px;
	${(props) => (props.isAbove ? 'bottom: 100%;' : 'top: calc(100% + 10px);')}
`;

export const StyledOptionContainer = styled.li<{ disabled?: boolean }>`
	color: ${({ disabled }) => (disabled ? '#a2a2a2	' : '#3f4254')};
	background-color: white;
	cursor: pointer;
	padding: 5px 20px;
	:hover {
		color: ${({ disabled }) => (disabled ? '' : ' #0095e8')};
		background-color: ${({ disabled }) =>
			disabled ? 'transparent' : '#f1faff'};
		transition: all 0.2s ease;
		border-radius: 4px;
	}
`;

export const StyledTextOption = styled(Header).attrs({
	variant: 'h6',
	weight: 'semibold',
})`
	color: inherit;
`;

export const StyledSelectText = styled(Header).attrs<{}, HeaderProps>(
	(props) => ({
		weight: 'semibold',
	})
)`
	font-size: 1.15rem;

	color: ${(props) => props.color};
	margin: 0;
`;

export const ContainerArrow = styled.div<{ disabled: boolean }>`
	position: absolute;
	top: 16px;
	right: 16px;
	:hover {
		cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
	}

	.fa-icon {
		transition: transform 0.3s ease-in-out;
	}

	.fa-icon.rotate {
		transform: rotate(180deg);
	}
`;
